import React from "react";
import { ClipboardListIcon, PillIcon, PuzzleIcon, SaladIcon, BoxIcon } from "lucide-react";
import { pillars, PillarIcon } from "../data/content";
const icons: Record<PillarIcon, BoxIcon> = {
  protocol: ClipboardListIcon,
  nutrition: SaladIcon,
  supplements: PillIcon,
  signals: PuzzleIcon
};
export function Solution() {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-221" data-mp="15qpnq2k93zzf">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-222" data-mp="qui6nb453eod">
        <header className="mx-auto max-w-narrow text-center" data-id="element-223" data-mp="qxcpiy7i8rfo">
          <h2 className="font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-224" data-mp="vuw1tskn6u4z">
            No estás rota.
            <br data-id="element-225" data-mp="mtepmlacvclk" />
            <span className="text-gold-600" data-id="element-226" data-mp="mswkt09mnq21">Tu cuerpo cambió de idioma.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-blue-900/75 md:text-xl" data-id="element-227" data-mp="2c8m918725yiu">
            La mayoría de las mujeres siente que su cuerpo las traiciona a los 45+. Pero lo que
            realmente pasó es que el “manual de usuario” cambió y nadie te lo explicó.
          </p>
          <p className="mx-auto mt-6 font-display text-xl font-extrabold tracking-tight text-blue-600 md:text-2xl" data-id="element-228" data-mp="2zey7fx4zz5b">
            El Sistema BIO-RESET te enseña a leer el nuevo idioma de tu cuerpo.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 md:grid-cols-2" data-id="element-229" data-mp="bsi8jfchjvvq">
          {pillars.map(pillar => {
          const Icon = icons[pillar.icon];
          return <li key={pillar.title} className="flex h-full gap-4 rounded-2xl bg-white p-6 shadow-soft ring-1 ring-blue-100 md:p-7" data-id="element-230" data-mp="3k93lt8c5hb4n">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-900 text-gold-300" data-id="element-231" data-mp="3u5zo2wbgh10r">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-232" data-mp="3p5lp03ru11ev" />
                </span>
                <span data-id="element-233" data-mp="19e66i4olam9d">
                  <span className="block font-display text-xl font-extrabold tracking-tight text-ink" data-id="element-234" data-mp="19do0whg1evos">
                    {pillar.title}
                  </span>
                  <span className="mt-2 block text-blue-900/75" data-id="element-235" data-mp="1chlpy2g2jg24">{pillar.description}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}